/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { CareportTeamViewModel } from './CareportTeamViewModel'; 

export function getCareportTeamsOptions(onSuccess?: (result: CareportTeamViewModel[]) => void) {
	return queryOptions({
		queryKey: ['careport-teams'],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/legacy/hospitalizations/getcareportteams/';
			const resp = await axios.get<CareportTeamViewModel[]>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: true
	});
}